"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useConfig;
var _reactRedux = require("react-redux");
var _selectors = require("../selectors");
var _useProps2 = _interopRequireDefault(require("./useProps"));
var _lodash = _interopRequireDefault(require("lodash.get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 *
 * @param {string} configPath the path for configurations of
 * the widget you want to get
 * @param {*} defaultValue the value that is returned if it
 * couldn't find the property using the path
 * @returns the widget configurations
 */
function useConfig(configPath, defaultValue) {
  var _useProps = (0, _useProps2.default)(),
    __instanceId = _useProps.__instanceId;
  var config = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.configSelector)(state, __instanceId);
  }) || {};
  return configPath ? (0, _lodash.default)(config, configPath, defaultValue) : config;
}